<i18n>
de:
  oneTime: einmalig
  month: monatlich
  from: ab

en:
  oneTime: one-time
  month: monthly
  from: from
</i18n>

<template>
  <agile
    :options="sliderOptions"
    :class="{
      'multiple-slides': slideCount > 1,
      'single-slide': slidesToShow < 2
    }"
  >
    <a
      v-for="(item, index) of items"
      :key="index"
      @mousedown="handleMouseDown"
      @mouseup="handleMouseUp"
      @click="handleClick"
      class="relative"
      :href="`/checkout/${item._id}`"
    >
      <div
        class="p-2 text-white absolute z-10 right-3 top-0 bg-primary-500 shadow text-sm rounded-bl-lg rounded-tr-lg"
      >
        <div class="text-right">
          <span v-if="customPrice(item)">{{ $t('from') }}&nbsp;</span>
          <span class="text-base font-bold">
            {{ calcAmount(item) }}
          </span>

          <div class="text-xs">
            {{ $t(item.itemType === 'product' ? 'oneTime' : 'month') }}
          </div>
        </div>
      </div>
      <div class="relative rounded-lg overflow-hidden bg-secondary-100">
        <div class="pb-full"></div>
        <transition
          enter-active-class="transition ease-out duration-400"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition ease-in duration-400"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div>
            <img
              class="absolute left-0 top-0 w-full h-full object-cover"
              :src="imgUrl(item)"
            />
            <div
              class="w-full p-2 text-white absolute left-0 bottom-0 bg-secondary-500"
            >
              <div class="text-xs" :class="{ 'text-sm': slidesToShow < 2 }">
                {{ item.name }}
              </div>
            </div>
          </div>
        </transition>
      </div>
    </a>
  </agile>
</template>

<script>
import { VueAgile } from 'vue-agile'

import { sync } from 'vuex-pathify'

export default {
  props: ['items', 'slideCount'],
  components: { agile: VueAgile },
  data() {
    return {
      allowClick: true,
      clientXY: 0
    }
  },
  computed: {
    userId: sync('reward/userId'),
    sliderOptions() {
      return {
        navButtons: this.multipleAllowed,
        dots: this.multipleAllowed,
        pauseOnDotsHover: true,
        autoplay: this.multipleAllowed,
        autoplaySpeed: 8000,
        slidesToShow: this.slidesToShow,
        fade: !this.multipleAllowed,
        infinite: true,
        centerMode: true,
        unagile: !this.multipleAllowed
      }
    },
    slidesToShow() {
      return this.multipleAllowed ? this.slideCount : 1
    },
    multipleAllowed() {
      return this.items.length === 1
        ? false
        : this.items.length >= this.slideCount
    }
  },
  methods: {
    imgUrl(item) {
      return `/services/media/image/${this.userId}/${item.image.name}/323/0/image.jpeg`
    },
    calcAmount(item) {
      return this.$n(
        Math.max(Number(item.amount || 0), Number(item.minAmount || 0)) / 100,
        'currency'
      )
    },
    customPrice(item) {
      return Number(item.minAmount) === this.calcAmount(item)
    },
    handleMouseDown(event) {
      this.clientXY = event.clientX + event.clientY
    },
    handleMouseUp(event) {
      this.allowClick = this.clientXY - event.clientX - event.clientY === 0
    },
    handleClick(event) {
      if (!this.allowClick) event.preventDefault()
    }
  }
}
</script>
<style>
.agile__nav-button {
  @apply bg-black bg-opacity-25 border-0 absolute top-1/2 h-12 w-12 text-white cursor-pointer duration-300 text-lg shadow-lg -mt-6;
}

.agile__nav-button:hover {
  @apply bg-primary-500 opacity-100;
}

.agile__nav-button--prev {
  @apply left-0 -mt-10 rounded-r-lg;
}

.agile__nav-button--next {
  @apply right-0 -mt-10 rounded-l-lg;
}

.agile__dots {
  @apply pt-10 mx-auto;
}

.agile__dot button {
  @apply w-2.5 h-2.5 bg-gray-300 block h-3 w-3 mx-2 border-0 rounded-full cursor-pointer duration-100;
}

.agile__dot--current button {
  @apply bg-primary-500 rounded-full ring-2 ring-primary-300 ring-offset-2;
}

.multiple-slides {
  @apply -mx-4;
}

.multiple-slides .agile__slide {
  @apply px-3;
}

.multiple-slides .agile__nav-button--next {
  @apply right-3;
}

.multiple-slides .agile__nav-button--prev {
  @apply left-3;
}

.single-slide a {
  @apply w-2/3;
}

.single-slide .agile__slides--regular .agile__slide {
  @apply mx-auto;
}

@screen lg {
  .single-slide .agile__slides--regular .agile__slide {
    @apply ml-0;
  }

  .required-purchases .single-slide .agile__slides--regular .agile__slide {
    @apply mx-auto;
  }
}
</style>
